import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class MediaComponent implements OnInit {
  loading : boolean = true;
  showTopics: boolean = true;
  title: string = "";

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      let category: string = routeParams.category;

      if(category && category.length > 0)
        this.setTopic(category);
    })
  }

  gotoTopic(id: number){

  }

  navigateTo(url: string){
    this.router.navigateByUrl('/media/'+url)
  }

  setTopic(topic: string){
    this.showTopics = false;
    this.title = topic.split('-').join(' ').toUpperCase();
  }
}
